export const checkInvalidInputVal = (val, isRequired = true) => {
  if (isRequired) {
    return val === undefined || val === null || val === ''
  } else return false
}

export const checkPhoneValid = (value, disableRequired = false) => {
  if (!value) return disableRequired
  const phoneNumber = /^\+?[0-9]*$/gi
  return phoneNumber.test(value)
}

export const checkEmailValid = (value, disableRequired = false) => {
  if (!value) return disableRequired
  const email = /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/gi
  return email.test(value)
}
